import { TouchableOpacity, TouchableHighlight, TouchableWithoutFeedback // @ts-ignore
} from './Touchables';
export default {
  TouchableOpacity: TouchableOpacity,
  TouchableHighlight: TouchableHighlight,
  TouchableWithoutFeedback: TouchableWithoutFeedback
};
//# sourceMappingURL=index.js.map